module.exports = __webpack_public_path__ + "img/0xCAb599D699f818e6ceFd07cF54f448DAB9367B05.2ffb9202.png";